import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex mb-3 font-bold" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "mx-1"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Fulfillment Warning")
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  Approve ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-double" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  Verify address ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plane-slash" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  Cancel ship ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("  Reject ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-bill-wave-alt" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("  Refund ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Request Seller ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play-circle" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Unhold ")
const _hoisted_25 = { class: "flex mb-3 font-bold" }
const _hoisted_26 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Order date: ")
const _hoisted_28 = { class: "font-normal" }
const _hoisted_29 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Created: ")
const _hoisted_31 = { class: "font-normal" }
const _hoisted_32 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Submit: ")
const _hoisted_34 = { class: "font-normal" }
const _hoisted_35 = {
  key: 3,
  class: "text-xs"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Approve: ")
const _hoisted_37 = { class: "font-normal" }
const _hoisted_38 = {
  key: 4,
  class: "text-xs"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Transaction ID: ")
const _hoisted_40 = { class: "font-normal" }
const _hoisted_41 = {
  key: 5,
  class: "text-xs"
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Invoice: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_copy_document = _resolveComponent("copy-document")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RequestSellerDialog = _resolveComponent("RequestSellerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboardOrderName(_ctx.state.order.orderName))),
              class: "mx-1",
              title: _ctx.state.order.orderName,
              style: {"font-size":"1.25rem"}
            }, _toDisplayString(_ctx.state.order.orderName), 9, _hoisted_4),
            (
            _ctx.state.order?.fulfillmentWarning || _ctx.state.order.addressValid === 0
          )
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_component_el_popover, {
                    placement: "top-start",
                    width: "auto",
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_icon, { style: {"color":"red"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Warning)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          (_ctx.state.order?.fulfillmentWarning)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                class: "mt-3 font-light"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getWarningContent(_ctx.state.order?.fulfillmentWarning)), 1)
                                ]),
                                _: 1
                              }))
                            : (_ctx.state.order.addressValid === 0)
                              ? (_openBlock(), _createBlock(_component_el_row, {
                                  key: 1,
                                  class: "mt-3 font-light"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.state.order?.errorMsg || 'Address Invalid!'), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "#",
              class: "mx-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboardOrderName(_ctx.state.order.orderName))),
              title: "Copy to clipboard"
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_copy_document)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _createVNode(_component_el_tag, {
              type: _ctx.getOrderStatusColor(_ctx.state.order.status),
              size: "small",
              title: _ctx.state.order?.comment ? _ctx.state.order.comment : _ctx.state.order.status
            
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.order.status), 1)
              ]),
              _: 1
            }, 8, ["type", "title"]),
            _createVNode(_component_el_tag, {
              type: "info",
              size: "small",
              title: "Source",
              class: "ml-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.order.source), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tag, {
              type: _ctx.getAddressStatusColor(_ctx.state.order?.addressValid),
              effect: "dark",
              class: "ml-3 rounded",
              size: "small",
              title: _ctx.addressTitleMap.get(_ctx.state.order?.addressValid)
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.addressTitleMap.get(_ctx.state.order?.addressValid)), 1)
              ]),
              _: 1
            }, 8, ["type", "title"]),
            _createVNode(_component_el_tag, {
              type: _ctx.state.order?.designStatus === 2 ? 'success' : 'error',
              size: "small",
              title: "Artwork status",
              class: "ml-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.order?.designStatus === 2 ? 'Completed' : 'Incomplete'), 1)
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_el_tag, {
              type: _ctx.state.order?.isUseLattePayment ? 'primary' : 'info',
              size: "small",
              title: "",
              class: "ml-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.order?.isUseLattePayment
                ? 'LatteX Payment'
                : 'Seller Payment'), 1)
              ]),
              _: 1
            }, 8, ["type"]),
            (_ctx.state.order?.catalogType?.length > 0)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _ctx.state.order.catalogType[0] === 'pod' ? 'primary' : 'info',
                  size: "small",
                  title: _ctx.state.order.catalogType[0],
                  class: "ml-3",
                  style: {"text-transform":"uppercase"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.order.catalogType[0]), 1)
                  ]),
                  _: 1
                }, 8, ["type", "title"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.userInfo?.userType === _ctx.UserTypes.AGENCY && _ctx.isShowActions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_dropdown, { trigger: "click" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmitApprove([_ctx.state.order._id]))),
                        disabled: !_ctx.validateApproved(_ctx.state.order.status)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.verifyAddressOrder([_ctx.state.order._id]))),
                        disabled: !_ctx.validateVerifyAddress(_ctx.state.order.status) ||
                _ctx.state.order?.addressValid !== _ctx.ADDRESS_STATUS.US_INVALID
                
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmitCancelShip([_ctx.state.order._id]))),
                        disabled: !_ctx.validateCancelShip(_ctx.state.order.status)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15,
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSubmitReject([_ctx.state.order._id]))),
                        disabled: !_ctx.validateReject(_ctx.state.order.status)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToRefundPage(_ctx.state.order._id)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickRequestSeller(_ctx.state.order)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeOrderOld())),
                        title: _ctx.isOrderUpdatedToOld(_ctx.state.order)
                ? 'Cập nhật đơn từ _OLD về bình thường'
                : 'Cập nhật đơn về _OLD'
                
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.isOrderUpdatedToOld(_ctx.state.order)
                  ? 'fas fa-link'
                  : 'fas fa-unlink'
                  )
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(_ctx.isOrderUpdatedToOld(_ctx.state.order)
                    ? '_OLD to Normal'
                    : 'Order to _OLD'), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubmitUnholdOrder([_ctx.state.order._id]))),
                        disabled: !_ctx.validateUnHold(_ctx.state.order.status)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "text" }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      (_ctx.state.order.createdAt)
        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatTime(_ctx.state.order.createdAt)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.order.createdDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _hoisted_30,
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatTime(_ctx.state.order.createdDate)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.order.items[0]?.submitDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _hoisted_33,
            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formatTime(_ctx.state.order.items[0]?.submitDate)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.order?.approveDate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _hoisted_36,
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatTime(_ctx.state.order?.approveDate)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.order?.transactionId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _hoisted_39,
            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.state.order?.transactionId), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.order?.invoice && _ctx.isShowActions)
        ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
            _createVNode(_component_el_divider, { direction: "vertical" }),
            _hoisted_42,
            (_ctx.state.order?.rejectedInvoiceId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { path: `/ag/invoices/${_ctx.state.order.rejectedInvoiceId}` }
                }, {
                  default: _withCtx(({ href }) => [
                    _createVNode(_component_el_link, {
                      href: href,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.order.rejectedInvoiceId), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_ctx.state.order?.invoice)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { path: `/ag/invoices/${_ctx.state.order.invoice}` }
                  }, {
                    default: _withCtx(({ href }) => [
                      _createVNode(_component_el_link, {
                        href: href,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.state.order.invoice), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_RequestSellerDialog, {
      ref: "requestSellerDialog",
      onOnAfterResquestSeller: _ctx.refresh
    }, null, 8, ["onOnAfterResquestSeller"])
  ], 64))
}